import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Linkedin, Twitter, Github, ArrowUpRight, ShieldCheck } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_shield-ai-15/artifacts/c1y3m0hp_ChatGPT%20Image%20Jun%203%2C%202026%2C%2012_41_18%20PM.png";

const COLS = [
  {
    title: "Ecosystem",
    links: [
      { label: "The Ecosystem", to: "/ecosystem" },
      { label: "Enterprise Security", to: "/enterprise-security" },
      { label: "Cyber Awareness", to: "/awareness" },
      { label: "Workforce", to: "/workforce" },
      { label: "Corporate Training", to: "/training" },
      { label: "Cyber Assistance", to: "/assistance" },
      { label: "Future SOC & Labs", to: "/labs" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About Us", to: "/about" },
      { label: "Alliances", to: "/alliances" },
      { label: "Industries", to: "/industries" },
      { label: "Careers", to: "/careers" },
      { label: "MSSP", to: "/mssp" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Threat Alerts", to: "/blog" },
      { label: "Blog", to: "/blog" },
      { label: "1930 Awareness", to: "/assistance" },
      { label: "Contact", to: "/contact" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0A1B5E] text-white relative overflow-hidden">
      <div className="absolute inset-0 dark-strip-bg opacity-100" />
      <div className="relative container-cd pt-20 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <Link to="/" className="inline-block" data-testid="footer-logo-link">
              <img src={LOGO} alt="Cosmos Defence" className="h-20 w-auto object-contain bg-white/95 rounded-2xl p-2" />
            </Link>
            <p className="mt-5 text-slate-300 text-sm leading-relaxed max-w-md">
              Cosmos Defence is a cybersecurity, awareness and digital safety ecosystem initiative under
              Cosmos Next Gen Tech Pvt Ltd (CNGTPL). Protecting people, enterprises and digital infrastructure across India.
            </p>

            <div className="mt-6 flex items-center gap-3">
              {[
                { Icon: Linkedin, href: "https://www.linkedin.com", id: "linkedin" },
                { Icon: Twitter, href: "https://x.com", id: "twitter" },
                { Icon: Github, href: "https://github.com", id: "github" },
              ].map(({ Icon, href, id }) => (
                <a key={id} href={href} target="_blank" rel="noreferrer"
                  data-testid={`footer-social-${id}`} aria-label={id}
                  className="h-10 w-10 grid place-items-center rounded-full border border-white/15 hover:border-cyan-300 hover:text-cyan-300 transition-colors">
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {COLS.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <div className="font-mono-tech text-[10px] tracking-[0.22em] text-cyan-300 uppercase mb-4">{col.title}</div>
              <ul className="space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                      className="text-slate-300 hover:text-white text-sm font-display transition-colors">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-2">
            <div className="font-mono-tech text-[10px] tracking-[0.22em] text-cyan-300 uppercase mb-4">Contact</div>
            <ul className="space-y-3 text-sm text-slate-300">
              <li className="flex items-start gap-3">
                <Mail size={16} className="mt-0.5 text-cyan-300" />
                <a href="mailto:secure@defence.cngtpl.com" className="hover:text-white" data-testid="footer-contact-email">
                  secure@defence.cngtpl.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={16} className="mt-0.5 text-cyan-300" />
                <a href="tel:+919315649601" className="hover:text-white" data-testid="footer-contact-phone">
                  +91 93156 49601
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 text-cyan-300" />
                <span data-testid="footer-contact-address">
                  208, H-73, H Block, Sector 63,<br />Noida, Uttar Pradesh — 201309
                </span>
              </li>
              <li className="flex items-start gap-3">
                <ShieldCheck size={16} className="mt-0.5 text-cyan-300" />
                <span data-testid="footer-1930">
                  <span className="font-mono-tech tracking-wider text-cyan-200">1930</span> · National Cyber Helpline
                </span>
              </li>
            </ul>
            <Link to="/contact?type=consultation" data-testid="footer-cta-talk" className="btn-accent mt-6 text-sm w-full justify-center">
              Request Consultation <ArrowUpRight size={16} />
            </Link>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2 text-xs text-slate-400 font-mono-tech tracking-wider">
            <ShieldCheck size={14} className="text-cyan-300" />
            © {new Date().getFullYear()} Cosmos Next Gen Tech Pvt Ltd. All rights reserved.
          </div>
          <div className="flex items-center gap-5 text-xs text-slate-400 font-mono-tech tracking-wider">
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Terms</a>
            <a href="#" className="hover:text-white">DPDP Compliance</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
